<template>
	<div class="shop">
		<!-- 顶部导航 -->
		<div class="nav">
			<van-icon name="arrow-left" color="#fff" size="1.2rem" @click="back" />
			<span>我的店铺</span>
			<span></span>
		</div>
		<div class="container">
			<van-field v-model="obj.title" label="店名:" placeholder="请输入店名" />
			<div class="van-cell van-field">
				<div class="van-cell__title van-field__label">
					<span>发布者</span>
				</div>
				<div class="van-cell__value">
					<van-radio-group v-model="radio" class="van-radios">
						<van-radio name="1" checked-color="#F1452F" icon-size="1rem">个体</van-radio>
						<van-radio name="2" checked-color="#F1452F" icon-size="1rem">公司</van-radio>
					</van-radio-group>
				</div>
			</div>
			<van-field v-model="obj.business" label="业务关健词:" placeholder="请输入店铺业务关健词" />
			<van-field>
				<div slot="label">选择分类:</div>
				<van-cell class="address" slot="input" :title="type" is-link @click="server=true" />
			</van-field>
			<van-field v-model="obj.tel" label="联系电话:" placeholder="请输入联系人电话" />
			<van-field v-model="addressMsg" readonly type="text" label="所在地区:" placeholder="请选择所在地区" @click="showAds=true">
				<div slot="right-icon" style="display:flex;align-items:center;color:#F1452F">
					<img src="../../assets/address.png" style="width:0.8rem" alt="">
					<span>&nbsp;定位</span>
				</div>
			</van-field>
			<van-field v-model="obj.address" label="业务地址:" placeholder="请输入业务地址" />
		</div>
		<div class="footer">
			<van-panel title="上传店铺图片">
				<div class="default">
					<van-uploader :before-delete="delImg" :after-read="subCamera" v-model="fileList" :max-count="9" />
				</div>
			</van-panel>
		</div>
		<div class="article">
			<van-panel title="业务图片">
				<div class="default">
					<van-uploader :before-delete="delImg1" :after-read="subCamera1" v-model="fileLists" :max-count="9" />
				</div>
			</van-panel>
		</div>
		<div class="article">
			<van-panel title="业务简介">
				<div class="default">
					<van-field v-model="obj.content" rows="2" autosize type="textarea" maxlength="500" :show-word-limit="showWordLimit"
					 placeholder="请输入10-500字的业务介绍">
					</van-field>
					<div class="van-field__word-limit" v-if="error">
						<div>还差<span>{{error_msg}}</span>个字</div>
					</div>
				</div>
			</van-panel>
		</div>
		<div class="submit">
			<van-button round color="#F1452F" size="small" @click="submit">立即提交</van-button>
		</div>
		<!-- 详细地址 -->
		<van-popup v-model="showAds" position="bottom" :style="{ 'height': '95%' }">
			<Map @close="close" @sites="sites"></Map>
		</van-popup>
		<!-- 服务类型 -->
		<van-popup v-model="server" position="bottom" :style="{ 'max-height': '80%' }">
			<van-picker :columns="columns" show-toolbar @cancel="server=false" @confirm="onConfirm" />
		</van-popup>
	</div>
</template>

<script>
	import Map from '@/components/map'
	import {
		compressImage
	} from '../../assets//js/compressImage'

	export default {
		data() {
			return {
				fileList: [],
				fileLists: [],
				annex: [],
				annexs: [],
				select: false,
				server: false,
				columns: [],
				radio: '',
				type: '',
				address: '',
				addressMsg: '',
				province: '',
				city: '',
				area: '',
				category_id: '',
				obj: '',
				error_msg: '10',
				error: true,
				showWordLimit: false,
				showAds: false,
				lat: '',
				lng: '',
				location: []
			}
		},
		components: {
			Map
		},
		created() {
			// 服务分类
			this.$axios.post(baseUrl + '/mobile/Category/thirdparty')
				.then((res) => {
					if (res.data.code == 2) {
						let obj = res.data.data;
						for (let i in obj) {
							this.columns.push({
								text: obj[i].title,
								children: []
							})
							for (let o in obj[i].category) {
								this.columns[i].children.push({
									text: obj[i].category[o].title,
									id: obj[i].category[o].id
								})
							}
						}
					}
				}).catch((err) => {
					console.log(err);
				});
			// 店铺信息
			this.$axios.post(baseUrl + '/mobile/Category/thirdpartyUser', {
				token: localStorage.getItem('Authorization')
			}).then((res) => {
				if (res.data.code === 2) {
					this.obj = res.data.data;
					this.type = this.obj.cat_title.title + ',' + this.obj.category_title.title;
					this.category_id = this.obj.category_title.id;
					this.address = this.obj.address;
					this.addressMsg = this.obj.province + this.obj.city + this.obj.area;
					this.province = this.obj.province;
					this.city = this.obj.city;
					this.area = this.obj.area;
					this.radio = this.obj.category + '';
					this.annex = this.obj.image;
					this.annexs = this.obj.slider_image;
					this.location.push(this.obj.lng, this.obj.lat);
					for (var i = 0; i < this.obj.image.length; i++) {
						this.fileList.push({
							url: "https://backstage.jbj-china.com.cn/uploads" + this.obj.image[i]
						})
					}
					for (var i = 0; i < this.obj.slider_image.length; i++) {
						this.fileLists.push({
							url: "https://backstage.jbj-china.com.cn/uploads" + this.obj.slider_image[i]
						})
					}
				}
			}).catch((err) => {})
		},
		watch: {
			'obj.content': function(value) {
				if (value.length > 10) {
					this.error = false;
					this.showWordLimit = true;
				} else {
					this.error = true;
					this.showWordLimit = false;
					this.error_msg = 10 - parseInt(value.length);
				}
			}
		},
		methods: {
			async afterDelete(file) {
				this.isloadImg = true;
				this.formArrayB.shift(file.url);
			},

			//接收子组件返回的地址
			sites(e) {
				AMap.plugin('AMap.Geocoder', () => {
					// 这里通过高德 SDK 完成。
					var geocoder = new AMap.Geocoder({
						radius: 1000,
						extensions: "all"
					});
					geocoder.getAddress([e.location.lng, e.location.lat], (status, result) => {
						if (status === 'complete' && result.info === 'OK') {
							if (result && result.regeocode) {
								// 具体地址
								self.address = result.regeocode.formattedAddress;
								// 省
								self.province = result.regeocode.addressComponent.province;
								// 市
								self.city = result.regeocode.addressComponent.city;
								// 区
								self.district = result.regeocode.addressComponent.district;
								this.addressMsg = self.province + self.city + self.district;
								this.province = self.province;
								this.city = self.city;
								this.area = self.district;
							}
						} else {
							this.$toast('系统繁忙,请重试');
						}
					})
				});
				this.obj.address = e.address;
				this.lat = e.location.lat;
				this.lng = e.location.lng;
				this.showAds = false;
			},
			// 上传附件1
			subCamera(file) {
				var that = this;
				let content = file.file;
				let data = new FormData();
				data.append('file', content);
				that.$axios.post(baseUrl + '/mobile/Index/imgUpload', data, {
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				}).then(function(res) {
					if (res.data.code == 11) {
						that.$toast(res.data.msg);
						that.annex.push(res.data.data);
					}
				}).catch(function(err) {
					console.log(err);
				})
				console.log(that.annex)
				console.log(that.fileList)
			},
			// 删除图片
			delImg(file, detail) {
				return new Promise((resolve, reject) => {
					this.$dialog.confirm({
						message: '确认删除图片？'
					}).then(() => {
						// 存放图片的数组
						this.annex.splice(detail.index, 1)
						this.$toast.success('删除成功')
						resolve()
					}).catch(error => {
						this.$toast.fail('已取消')
						reject(error)
					})
				})
			},
			// 上传附件2
			subCamera1(file) {
				var that = this;
				let content = file.file;
				let data = new FormData();
				data.append('file', content);
				that.$axios.post(baseUrl + '/mobile/Index/imgUpload', data, {
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				}).then(function(res) {
					if (res.data.code == 11) {
						that.$toast(res.data.msg);
						that.annexs.push(res.data.data);
					}
				}).catch(function(err) {
					console.log(err);
				})
			},
			// 删除图片
			delImg1(file, detail) {
				return new Promise((resolve, reject) => {
					this.$dialog.confirm({
						message: '确认删除图片？'
					}).then(() => {
						// 存放图片的数组
						this.annexs.splice(detail.index, 1)
						this.$toast.success('删除成功')
						resolve()
					}).catch(error => {
						this.$toast.fail('已取消')
						reject(error)
					})
				})
			},
			//关闭选择地址
			close(res) {
				this.showAds = res;
			},
			//分类确认选择
			onConfirm(value, index) {
				this.server = false;
				this.type = value.toString();
				this.category_id = this.columns[index[0]].children[index[1]].id;
			},
			//选中地址
			areaOk(event) {
				this.address = '';
				for (var item in event) {
					this.address += event[item].name;
				}
				this.province = event[0].name;
				this.city = event[1].name;
				this.area = event[2].name;
				this.select = false;
			},

			// 修改请求
			shopUpdate() {
				this.$axios.post(baseUrl + '/mobile/Category/thirdpartyAUpdate', {
					id: this.$route.query.id,
					title: this.obj.title,
					business: this.obj.business,
					category_id: this.category_id,
					tel: this.obj.tel,
					province: this.province,
					city: this.city,
					area: this.area,
					address: this.obj.address,
					content: this.obj.content,
					image: this.annex,
					slider_image: this.annexs,
					category: this.radio,
					lat: this.lat,
					lng: this.lng
				}).then((res) => {
					const toast = this.$toast.loading({
						duration: 0,
						forbidClick: true,
						message: '提交中',
						loadingType: 'spinner'
					});
					if (res.data.code === 7) {
						this.$toast.clear();
						this.$toast(res.data.msg);
						this.back();
					}
				}).catch(() => {
					console.log(err);
				})
			},
			//立即修改
			submit() {
				if (this.obj.title == '') {
					this.$toast('店铺名不能为空！');
					return false;
				};
				if (this.fileList.length == 0) {
					this.$toast('请上传业务图片！');
					return false;
				};
				if (this.fileLists.length < 2) {
					this.$toast('店铺图片太少！');
					return false;
				};
				if (this.obj.business == '') {
					this.$toast('业务关健词不能为空！');
					return false;
				};
				if (this.type == '') {
					this.$toast('分类不能为空！');
					return false;
				};
				if (this.obj.tel == '') {
					this.$toast('手机号不能为空！');
					return false;
				};
				if (this.obj.tel && (!(/^[1][345789]\d{9}$/).test(this.obj.tel) || !(/^[1-9]\d*$/).test(this.obj.tel) ||
						this.obj.tel.length !== 11)) {
					this.$toast('手机号码不符合规范');
					return false;
				};
				if (this.addressMsg == '') {
					this.$toast('所在地区不能为空!');
					return false;
				};
				if (this.address == '') {
					this.$toast('业务地址不能为空!');
					return false;
				};
				if (this.obj.content == '') {
					this.$toast('业务详情不能为空!');
					return false;
				};
				if (this.obj.content.length < 10) {
					this.$toast('业务详情内容太少!');
					return false;
				};
				const toast = this.$toast.loading({
					duration: 0,
					message: '提交中',
					loadingType: 'spinner'
				});
				this.shopUpdate();
			}
		}
	}
</script>

<style scoped>
	.shop {
		padding-top: 2rem;
	}

	.shop .container .van-cell {
		font-size: 0.75rem;
		border-top: 1px solid #ebedf0;
		overflow-x: hidden;

		text-overflow: ellipsis;
	}

	.shop .van-field__label span {
		width: 100%;
	}

	.shop .container,
	.shop .article,
	.shop .footer {
		margin: 0.8rem;
		border-radius: 0.3rem;
		overflow: hidden;
		text-align: left;
	}

	.shop .article .van-panel__header,
	.shop .footer .van-panel__header {
		border-bottom: 1px solid #ebedf0;
	}

	.shop .van-cell:not(:last-child)::after {
		border: 0;
	}

	.shop .article .van-field__word-limit {
		padding: 0 1rem 1rem 0;
		box-sizing: border-box;
	}

	.shop .article .van-field__word-limit span {
		color: #F1452F;
		font-weight: bold;
	}

	.shop .van-uploader {
		margin: 0.7rem 0 0 0.7rem;
	}

	.shop .submit {
		height: 2rem;
		width: 100%;
		margin-bottom: 0.8rem;
	}

	.shop .submit .van-button {
		width: 80%;
	}

	.shop .address {
		padding: 0;
		border-top: 0 !important;
	}

	.shop .van-radios {
		font-size: 0.75rem;
		width: 65%;
		justify-content: space-between;
		display: flex;
	}
</style>



// WEBPACK FOOTER //
// src/components/min/shopUpdate.vue